import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalFooter, ButtonPrimary, ButtonPrimaryDark,
} from '@americanexpress/dls-react';
import {
  createIntl, createIntlCache, RawIntlProvider, FormattedMessage,
} from 'react-intl';
import copy from '../../locale/fr-FR.json';
import { FRANCE_HOME_PAGE } from '../utils/constants';

const cache = createIntlCache();
const bybIntl = createIntl(
  {
    locale: 'fr-FR',
    messages: copy,
  },
  cache
);

const QuitModal = ({ setShow }) => (
  <div>
    <RawIntlProvider value={bybIntl}>
      <Modal
        theme={{
          // allows the modal to be scrollable but scrollbar not to be shown
          '& > div': {
            marginTop: '4rem',
            maxWidth: '28rem',
            minWidth: '20.43rem',
            overflowY: 'auto',
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            '::-webkit-scrollbar': { display: 'none' },
          },
          '.css-19msrin:focus': {
            outline: 'none !important',
          },
        }}
        reactlytics={{ disable: true }}
      >
        <ModalFooter
          theme={{
            padding: '1.25rem 2.2rem !important',
            // overwrite the default footer alignment
            '& > div': {
              textAlign: 'center',
            },
          }}
        >
          <div className="row">
            <div className="flex flex-column col-md-12 margin-0-lr">
              <div className="margin-2-tb pad-0 margin-0">
                <h2 className="heading-2 margin-1-b" id="eligibility-header">
                  <FormattedMessage
                    id="leavethepageModal.heading"
                    defaultMessage="leavethepageModal.heading"
                  />
                </h2>
                <FormattedMessage
                  id="leavethepageModal.BodyText"
                  defaultMessage="leavethepageModal.BodyText"
                />
              </div>
              <div className="margin-1-tb pad-0 margin-0">
                <div className="margin-2-b">
                  <ButtonPrimary
                    onClick={() => setShow(false)}
                    reactlytics={{
                      element: 'Continue',
                      detail: 'Header',
                    }}
                  >
                    <FormattedMessage
                      id="leavethepageModal.ContinueBtnText"
                      defaultMessage="leavethepageModal.ContinueBtnText"
                    />
                  </ButtonPrimary>
                </div>
                <div className="margin-1-tb pad-0 margin-0">
                  <div className="margin-1-b">
                    <a href={FRANCE_HOME_PAGE}>
                      <ButtonPrimaryDark
                        reactlytics={{
                          element: 'LeavePage',
                          detail: 'Header',
                        }}
                      >
                        <FormattedMessage
                          id="leavethepageModal.ExitBtnText"
                          defaultMessage="leavethepageModal.ExitBtnText"
                        />
                      </ButtonPrimaryDark>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </RawIntlProvider>
  </div>
);

export default QuitModal;

QuitModal.propTypes = {
  setShow: PropTypes.func.isRequired,
};
